import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMapComponent } from "./med-icon-map.component";

@NgModule({
  declarations: [
    MedIconMapComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMapComponent,
  ],
})
export class MedIconMapModule { }
